// import { Navigate } from "react-router-dom";
// import { useSelector } from "react-redux";
// import Layout from "../components/Layout";

// const Private = ({ children }) => {
//   const { adminToken } = useSelector((state) => state.authReducer);


//   return adminToken ?
//     <Layout>
//       {children}
//     </Layout> :
//     <Navigate to="/" />;
// };

// export default Private;




import { Navigate } from "react-router-dom";
import { isSessionValid, clearSession } from "../utils/session";
import Layout from "../components/Layout";

const Private = ({ children }) => {
  if (!isSessionValid()) {
    clearSession();
    return <Navigate to="/" />;
  }
  return <Layout>{children}</Layout>;
};

export default Private;
